/**
 * Wave 4 TEST economy chrome — OfflineBanner when tenant is pre-go-live.
 * Mounted next to CustomerOfflineBanner (plan TEST chrome mounts).
 */
import { useTranslation } from 'react-i18next';
import { OfflineBanner } from '../shared/ui/OfflineBanner.js';
import { useCustomerFeatureFlagsQuery } from '../features/flags/customerFeatureFlagsApi.js';
import { isPlatformChromeTenant } from './platformChromeTenant.js';
import { useTenantCode } from '../shared/tenant/TenantProvider.js';
import { isReservedCustomerPathSegment } from '../features/auth/customerAuthPaths.js';
import { hasCustomerApiTenant } from '../shared/tenant/customerApiTenant.js';
import {
  CUSTOMER_SHELL_WIDTH_CLASS,
  CUSTOMER_TOP_BAR_CLEARANCE_TOP_CLASS,
} from './customerTopBarStyles.js';

export function CustomerTestEconomyBanner(): JSX.Element | null {
  const { t } = useTranslation('customer');
  const tenantCode = useTenantCode();
  const flagsQuery = useCustomerFeatureFlagsQuery();

  const tenantScoped =
    !isPlatformChromeTenant(tenantCode) &&
    !isReservedCustomerPathSegment(tenantCode) &&
    hasCustomerApiTenant(tenantCode);

  if (!tenantScoped || !flagsQuery.isSuccess) {
    return null;
  }

  const livePublishedAt = flagsQuery.data.livePublishedAt;
  if (livePublishedAt != null) {
    return null;
  }

  return (
    <div
      className={`customer-safe-area-x pointer-events-none sticky ${CUSTOMER_TOP_BAR_CLEARANCE_TOP_CLASS} z-30 px-3 pt-2 ${CUSTOMER_SHELL_WIDTH_CLASS} lg:[html[data-sidebar-visible]_&]:pl-56`}
      data-testid="customer-test-economy-banner-host"
    >
      <div className="pointer-events-auto">
        <OfflineBanner
          message={t('pwa.testEconomyBanner')}
          testId="customer-test-economy-banner"
        />
      </div>
    </div>
  );
}
